import { Button, Typography } from '@krakentech/coral';

import { StyledFaqList, StyledFaqListItem } from './index.styled';

import { FaqList } from '@/hooks/help-and-faqs/faqs/types';

const FaqsList = ({ faqs }: { faqs?: FaqList }) => {
    if (!faqs || !faqs.items.length) {
        return <Typography>No FAQs to display</Typography>;
    }

    return (
        <StyledFaqList>
            {faqs.items.map((faq) => (
                <StyledFaqListItem key={faq.content._uid}>
                    <Button
                        href={`/help-and-faqs/faqs/${faq.slug}`}
                        color="secondary"
                        variant="outlined"
                        fullWidth
                    >
                        {faq.content.title}
                    </Button>
                </StyledFaqListItem>
            ))}
        </StyledFaqList>
    );
};

export default FaqsList;
